import {Injectable} from "@angular/core";
import {LocalStorageService} from "./local-storage.service";
import {Constants} from "../constants";
import {AuthResponse} from "../models/responses/auth/access-token.response";

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  constructor(private localStorageService: LocalStorageService) {
  }

  private setRole(value: string): void {
    this.localStorageService.set(Constants.ROLE_KEY, value);
  }

  private removeRole(): void {
    this.localStorageService.remove(Constants.ROLE_KEY);
  }


  private setAccessToken(value: string): void {
    this.localStorageService.set(Constants.ACCESS_TOKEN_KEY, value);
  }

  public getAccessToken(): string | null {
    return this.localStorageService.get(Constants.ACCESS_TOKEN_KEY);
  }

  private removeAccessToken(): void {
    return this.localStorageService.remove(Constants.ACCESS_TOKEN_KEY);
  }

  private setRefreshToken(value: string): void {
    this.localStorageService.set(Constants.REFRESH_TOKEN_KEY, value);
  }

  private removeRefreshToken(): void {
    this.localStorageService.remove(Constants.REFRESH_TOKEN_KEY);
  }

  public getRefreshToken(): string | null {
    return this.localStorageService.get(Constants.REFRESH_TOKEN_KEY);
  }

  public setUserData(token: AuthResponse) {
    this.setRole(token.role[0]);
    this.setAccessToken(token.access_token);
    this.setRefreshToken(token.refresh_token);
  }

  public logout() {
    this.removeRole();
    this.removeAccessToken();
    this.removeRefreshToken();
  }

  public isAuthenticated() {
    return this.getAccessToken() == null;
  }
}
